<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :items-per-page="15"
    :search="search"
    :custom-filter="$options.localeIncludes"
    :loading="loading"
    :loading-text="$t('general.loading')"
    :sort-by="['date']"
    :sort-desc="[true]"
    @input="$emit('update:selected', $event)"
  >
    <template v-slot:[`item.date`]="{ item }">
      <ag-date-text
        :value="item.date"
        :format="$t('date.dateAndTime')"
      />
    </template>
    <template v-slot:[`item.label`]="{ item }">
      <span
        v-if="['consumption', 'refund'].includes(item.type)"
        v-text="$t('tokens.history.fields.sessionLabel', { label: item.label })"
      />
      <span v-else v-text="item.label" />
    </template>
    <template v-slot:[`item.type`]="{ item }">
      <span
        v-if="item.type"
        class="rounded-pill py-1 px-2 white--text"
        :class="$t(`tokens.history.type.${item.type}.color`)"
        v-text="$t(`tokens.history.type.${item.type}.label`)"
      />
    </template>
    <template v-slot:[`item.tokenNumber`]="{ item }">
      <span
        class="font-weight-medium mr-5"
        :class="item.tokenNumber > 0 ? 'success--text' : 'error--text'"
        v-text="item.tokenNumber.toLocaleString().replace('-', '- ')"
      />
    </template>
    <template v-slot:[`item.bill`]="{ item }">
      <v-btn
        v-if="item.bill"
        :href="item.bill"
        target="_blank"
        icon
        large
        color="accent"
        class="mr-4"
      >
        <v-icon>
          mdi-file-pdf
        </v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import Config from 'src/config'
import Helpers from 'src/utils/helpers'
import AgDateText from 'src/components/common/AgDateText'

export default {
  name: 'TokensHistoryList',
  components: {
    AgDateText,
  },
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    search: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: String,
      required: true,
    },
  },
  computed: {
    headers () {
      return [
        {
          text: this.$t('tokens.history.fields.date'),
          value: 'date',
        },
        {
          text: this.$t('tokens.history.fields.label'),
          value: 'label',
          align: 'center',
        },
        {
          text: this.$t('tokens.history.fields.type'),
          value: 'type',
          align: 'center',
        },
        {
          text: this.$t('tokens.history.fields.tokenNumber'),
          value: 'tokenNumber',
          align: 'right',
        },
        {
          text: this.$t('tokens.history.fields.bill'),
          value: 'bill',
          filterable: false,
          align: 'right',
        },
      ]
    },
    items () {
      return this.value.map(item => ({
        date: item.date,
        label: item.label,
        type: item.type,
        tokenNumber: item.tokenNumber || item.tokenNumber === 0 ? `${item.tokenNumber}` : '',
        bill: item.bill && `${Config.API_URL}company/${this.companyId}/tokenHistory/bill/${item.bill}`,
      }))
    },
  },
  localeIncludes: Helpers.localeIncludes,
}
</script>
